<template>
    <div class="blog-sidebar-item footer-social-links">
        <h1 class="heading-border-bottom-anim">Follow & connect</h1>
        <ul class="blog-follow-and-connect">
            <li>
                <a href="">
                    <span class="dlab-icon"><font-awesome-icon :icon="['fab', 'facebook-f']" /></span>
                    <span class="dlab-icon"><font-awesome-icon :icon="['fab', 'facebook-f']" /></span>
                </a>
            </li>
            <li>
                <a href="">
                    <span class="dlab-icon"><font-awesome-icon :icon="['fab', 'twitter']" /></span>
                    <span class="dlab-icon"><font-awesome-icon :icon="['fab', 'twitter']" /></span>
                </a>
            </li>
            <li>
                <a href="">
                    <span class="dlab-icon"><font-awesome-icon :icon="['fab', 'linkedin-in']" /></span>
                    <span class="dlab-icon"><font-awesome-icon :icon="['fab', 'linkedin-in']" /></span>
                </a>
            </li>
            <li>
                <a href="">
                    <span class="dlab-icon"><font-awesome-icon :icon="['fab', 'instagram']" /></span>
                    <span class="dlab-icon"><font-awesome-icon :icon="['fab', 'instagram']" /></span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'FollowAndConnect',
    data() {
        return {

        }
    }
}
</script>